// extracted by mini-css-extract-plugin
module.exports =  {"number-input":"number-input-igJ35","button":"button-GWY2o","icon":"icon-EndAk","number-display":"number-display-hLJ72","label":"label-y4qDZ","value":"value-Y2xdx"};